import React, { Component } from "react";
import { IDashboardTabComponent } from "../Dashboard";
import Strings from "@my-dld/assets/strings";
import { NullHandler } from "@my-dld/utils/ApiUtils";
import PageTitle from "@my-dld/components/PageTitle";
import * as SSO from "@10x/sso";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { withRouter } from "react-router";
import Summary from "./Summary";
import PortfolioContextWrapper from "@my-dld/contexts/PortfolioContext";
import { bindActionCreators, Dispatch } from "redux";
import * as XActions from "@my-dld/actions/PropertyActions";
import { connect } from "react-redux";
import { getAppServices } from "@10x/coreapp/index";

interface Props extends RoutedViewProps {
	loadAssets: () => void;
	loadLeases: ( eid: string ) => void;
	loadMapProperties: () => void;
}

interface XInfo {
	count: number;
	value: number;
	percent?: number;
}


interface State {
	isFirstPropertyLoad: boolean;
	isFirstLeaseLoad: boolean;
	isFirstMapLoad: boolean;
	isLoading: boolean;
}

class Portfolio extends Component<Props, State> implements IDashboardTabComponent<Props, State> {
	apiHandler: any;
	apiExHandler: any;

	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			isFirstPropertyLoad: true,
			isFirstLeaseLoad: true,
			isFirstMapLoad: true,
		};
	}

	componentWillUnmount(): void {
		this.apiHandler = NullHandler;
		this.apiExHandler = NullHandler;
	}

	componentDidMount(): void {
		this.setState( {
			isLoading: true,
		} );
		const store = getAppServices().storeService.getStore();
		if ( store.getState().UserData.leases ) {
			this.setState( {
				isFirstPropertyLoad: false,
			} );
		}
		this.props.loadAssets();
		this.props.loadMapProperties();
		if ( store.getState().UserData.leases ) {
			this.setState( {
				isFirstLeaseLoad: false,
			} );
		}
		if ( store.getState().UserData.mapProperties ) {
			this.setState( {
				isFirstMapLoad: false,
			} );
		}
		let emiratesID = SSO.getEmiratesID();
		if ( emiratesID )
			this.props.loadLeases( emiratesID );
	}

	render() {
		const pp = this.props.match.path;
		return (
			<React.Fragment>
                <PageTitle title={Strings.my_portfolio} />
				<PortfolioContextWrapper>
					<Summary/>
				</PortfolioContextWrapper>
			</React.Fragment>
		);
	}
}

function mapDispatch( dispatch: Dispatch ) {
	return bindActionCreators( XActions, dispatch );
}

export default connect( null, mapDispatch )( withRouter( Portfolio ) );
